import React, { useEffect, useState } from "react";
import { CargasTancadaApi } from "../api/CargasTancadaApi";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { useForm } from "react-hook-form";
import { IsAlmacenBultosSkim } from "../helpers/almacenSkim";
import { useReprocesoCarga } from "./useReprocesoCarga";
import { usePesajeBascula } from "../../../../../../../Utils/APIs/usePesajeBascula";

export const useCargasForm = (idTancada, regresar) => {
    const {
        getCargasTancada,
        agregarCargaTancada,
        eliminarCargaTancada,
        cargando,
    } = CargasTancadaApi();

    const [cargasTancada, setCargasTancada] = useState([]);
    const [numeroTancada, setNumeroTancada] = useState("");

    const GetCargasTancada = async () => {
        try {
            if (!idTancada) return;

            const data = await getCargasTancada(idTancada);

            setCargasTancada(data.cargas_tancada || []);
            setNumeroTancada(data.numero || "");
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las cargas de la tancada",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetCargasTancada();
    }, [idTancada]);

    // _________ BULTOS SKIM _________
    const [refreshBultosKey, setRefreshBultosKey] = useState(0);

    const RefrescarBultosSkim = () => {
        formSetValue("bulto_skim", null);
        setRefreshBultosKey((prev) => prev + 1);
    };

    // _________ FORMULARIO _________
    const form = useForm({
        mode: "onChange",
    });

    const {
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: watchForm,
        formState: { errors: formErrors },
    } = form;

    const formValues = watchForm();

    // en reproceso la carga se arma con lo que se toma del inventario del
    // almacén, no con el peso de la báscula
    const reproceso = useReprocesoCarga(formValues.almacen);

    const EnviarCarga = async (datosCarga) => {
        try {
            await agregarCargaTancada(idTancada, datosCarga);

            NotificationManager.success(
                "Carga agregada con éxito",
                "Éxito",
                3000,
            );

            // Limpiar campos del formulario
            formSetValue("almacen", null);
            formSetValue("bulto_skim", null);
            if (!formGetValues("carga_manual")) {
                formSetValue("kg_humedos", pesoBascula);
            } else {
                formSetValue("kg_humedos", null);
            }

            // refrescar listado
            await GetCargasTancada();
            RefrescarBultosSkim();

            return true;
        } catch (error) {
            console.error("Error al agregar carga tancada:", error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al agregar la carga",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            return false;
        }
    };

    const AgregarCargaTancada = async () => {
        const isValid = await validateForm();

        if (!isValid) return;

        const valores = formGetValues();

        const esAlmacenBultosSkim = IsAlmacenBultosSkim(valores);

        await EnviarCarga({
            almacen_id: valores.almacen.id,
            kg_humedos: valores.kg_humedos,
            bulto_skim_id:
                esAlmacenBultosSkim && valores.bulto_skim
                    ? valores.bulto_skim.id
                    : null,
        });
    };

    // en reproceso la carga se agrega desde el mismo modal: no hay peso de
    // báscula que validar y el almacén ya está seleccionado
    const AgregarCargaReproceso = async () => {
        if (!reproceso.haySeleccion) {
            NotificationManager.error(
                "Debe seleccionar el reproceso que se toma en la carga",
                "Error",
                3000,
            );
            return;
        }

        const agregada = await EnviarCarga({
            almacen_id: formGetValues("almacen").id,
            ...reproceso.ObtenerConsumos(),
        });

        if (agregada) reproceso.CerrarModal();
    };

    const EliminarCargaTancada = async (cargaId) => {
        try {
            await eliminarCargaTancada(idTancada, cargaId);
            NotificationManager.success(
                "Carga eliminada con éxito",
                "Éxito",
                3000,
            );
        } catch (error) {
            console.error("Error al eliminar carga tancada:", error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar la carga",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        } finally {
            // refrescar listado
            await GetCargasTancada();
            RefrescarBultosSkim();
            reproceso.Refrescar();
        }
    };

    const { pesoBascula } = usePesajeBascula({
        configuraciones: { peso_ingreso_manual: false },
    });

    useEffect(() => {
        if (pesoBascula !== null && !formValues.carga_manual) {
            formSetValue("kg_humedos", pesoBascula);
            validateForm("kg_humedos");
        }
    }, [pesoBascula, formValues.carga_manual]);

    useEffect(() => {
        RefrescarBultosSkim();
    }, [formValues.almacen]);

    const basculaConectada = pesoBascula !== null;

    return {
        cargasTancada,
        numeroTancada,
        GetCargasTancada,
        setCargasTancada,

        form,
        refreshBultosKey,
        reproceso,

        AgregarCargaTancada,
        AgregarCargaReproceso,
        EliminarCargaTancada,
        basculaConectada,
        cargando,
    };
};
